module.exports = __webpack_public_path__ + "img/company_back_green.db40094f.png";